import type { CheckoutOrder } from '@katsquare/types';

interface RazorpaySuccess {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}
interface RazorpayInstance {
  open: () => void;
}
type RazorpayCtor = new (opts: Record<string, unknown>) => RazorpayInstance;

const SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js';

/** Lazily load the Razorpay Checkout script. Resolves false if it can't load. */
function loadScript(): Promise<boolean> {
  return new Promise((resolve) => {
    const w = window as unknown as { Razorpay?: RazorpayCtor };
    if (w.Razorpay) return resolve(true);
    const s = document.createElement('script');
    s.src = SCRIPT;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

/**
 * Open Razorpay Checkout for a created order; calls onSuccess with the payload
 * to verify server-side. Returns false if the gateway couldn't be loaded.
 */
export async function openRazorpayCheckout(
  order: CheckoutOrder,
  who: { name?: string; email?: string },
  onSuccess: (r: RazorpaySuccess) => void,
): Promise<boolean> {
  if (!(await loadScript())) return false;
  const w = window as unknown as { Razorpay: RazorpayCtor };
  const rzp = new w.Razorpay({
    key: order.keyId,
    order_id: order.orderId,
    amount: order.amount,
    currency: order.currency,
    name: 'KatSquare Draft',
    description: `${order.plan[0] + order.plan.slice(1).toLowerCase()} plan — 1 month`,
    prefill: { name: who.name ?? '', email: who.email ?? '' },
    theme: { color: '#171717' },
    handler: (r: RazorpaySuccess) => onSuccess(r),
  });
  rzp.open();
  return true;
}
